import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import {
    FormGroupType,
    NestedFormGroupType,
} from '../../../../../../core/models/form-group-type';
import { CoordinationParametersFormModel } from '../../models/coordination-parameters-form-model';
import { IncludeFrequencyForValidationFormModel } from '../../models/include-frequency-for-validation/include-frequency-for-validation-form-model';
import { FrequencyPoolFormModel } from '../../models/frequency-pool/frequency-pool-form-model';
import { FriendlySelectionFormModel } from '../../models/friendly-selection/friendly-selection-form-model';

@Injectable({
    providedIn: 'root',
})
export class CoordinationParametersFormService {
    getFormDefinition(): FormGroup<
        NestedFormGroupType<CoordinationParametersFormModel>
    > {
        return new FormGroup<
            NestedFormGroupType<CoordinationParametersFormModel>
        >({
            applicationTypeCode: new FormControl<string | null>(
                null,
                Validators.required,
            ),
            frequencyAllocationCode: new FormControl<string | null>(null),
            frequencyPoolOptions: new FormArray<
                FormGroup<FormGroupType<FrequencyPoolFormModel>>
            >([]),
            includeFrequenciesForValidation: new FormArray<
                FormGroup<FormGroupType<IncludeFrequencyForValidationFormModel>>
            >([]),
            friendlySelection: new FormArray<
                FormGroup<FormGroupType<FriendlySelectionFormModel>>
            >([]),
        });
    }
}
